import React, {useEffect, useState} from 'react';
import './_filter.scss';
import VButton from "../../v-button/v-button";
import HouseList from "./house-list/house-list";
import RoomVariable from "./room-variable/room-variable";
import PriceVariable from "./price-variable/price-variable";
import SizeVariable from "./size-variable/size-variable";

import VStore from "../../../store";

export default function Filter() {
    const [isCollapsed, setIsCollapsed] = useState(false);


    const {currentFilter, setCurrentFilter} = VStore();

    const RoomBtnContent = <div className='w-100 d-flex justify-content-center align-items-center position-relative'>
        <img src="./assets/images/mini-left-arrow.svg" alt="Room"
             style={{position: 'absolute', left: '4px'}}
             className={currentFilter === 'room' ? 'active' : ''}
        />
        <span>Other Filters</span>
    </div>

    const PriceBtnContent = <div className='w-100 d-flex justify-content-center align-items-center position-relative'>
        <img src="./assets/images/mini-left-arrow.svg" alt="Price"
             style={{position: 'absolute', left: '4px'}}
             className={currentFilter === 'price' ? 'active' : ''}
        />
        <span>Price</span>
    </div>

    const HomeSizeBtnContent = <div
        className='w-100 d-flex justify-content-center align-items-center position-relative'>
        <img src="./assets/images/mini-left-arrow.svg" alt="Home Size"
             style={{position: 'absolute', left: '4px'}}
             className={currentFilter === 'size' ? 'active' : ''}
        />
        <span># of Sq. Ft.</span>
    </div>

    useEffect(() => {
        setCurrentFilter('');
    }, [isCollapsed]);

    return <div className="filter">
        <div className={isCollapsed ? 'collapsed' : ''}>
            <div className='filter__item filter__price-range'>
                <VButton content={PriceBtnContent} width='100%'
                         onClick={() => setCurrentFilter(currentFilter === 'price' ? '' : 'price')}
                />
                <PriceVariable/>
            </div>
            <div className='filter__item filter__price-range'>
                <VButton content={HomeSizeBtnContent} width='100%'
                         onClick={() => setCurrentFilter(currentFilter === 'size' ? '' : 'size')}
                />
                <SizeVariable/>
            </div>
            <div className='filter__item'>
                <VButton content={RoomBtnContent} width='100%'
                         onClick={() => setCurrentFilter(currentFilter === 'room' ? '' : 'room')}
                />
                <RoomVariable/>
            </div>
            <div className='filter__item filter__house-model flex-grow-1'>
                <div>
                    <div>
                        <h5>House Model</h5>
                        <HouseList/>
                    </div>
                </div>
            </div>
            <div className='d-flex align-items-center justify-content-around w-100'>
                <VButton content='Need help?' className='help-btn'/>
                <VButton content={<img src={"./assets/images/question.svg"} alt="Question"/>} className='question-btn'/>
            </div>
            <VButton className='filter__collapse-btn'
                     onClick={() => setIsCollapsed(!isCollapsed)}
                     content={<img src="./assets/images/double-arrow.svg" alt="Collapse"/>}
                     tooltip={isCollapsed ? 'Maximize filter' : 'Minimize filter'}
                     tooltipPosition='left'
            />
        </div>
    </div>;
}
